import Pendaftaran from "../../../../../components/categories/superadmin/master_data/pendaftaran/Home"

export default function Home() {  
  return (
    <Pendaftaran />
  );
}
